import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g id="blog" transform="translate(-3 -5)">
        <path
          id="Path_1423"
          data-name="Path 1423"
          d="M16.577,22.166,24,14.743V24.56A2.443,2.443,0,0,1,21.56,27H5.44A2.443,2.443,0,0,1,3,24.56V12H18.257l-5.923,5.923a2.5,2.5,0,0,0-.668,1.206l-.932,4.038a.5.5,0,0,0,.6.6l4.038-.932h0A2.5,2.5,0,0,0,16.577,22.166ZM13.042,18.63a1.5,1.5,0,0,0-.4.723l-.752,3.258,3.257-.751a1.5,1.5,0,0,0,.724-.4l9.848-9.848L22.889,8.782ZM19.257,11H3V7.44A2.443,2.443,0,0,1,5.44,5H21.56a2.431,2.431,0,0,1,2.226,1.471ZM7,8.5A.5.5,0,0,0,6.5,8h-1a.5.5,0,0,0,0,1h1A.5.5,0,0,0,7,8.5Zm3,0A.5.5,0,0,0,9.5,8h-1a.5.5,0,0,0,0,1h1A.5.5,0,0,0,10,8.5Zm3,0a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0,0,1h1A.5.5,0,0,0,13,8.5Zm14.485.636L25.364,7.015a.541.541,0,0,0-.708,0L23.6,8.075,26.425,10.9l1.061-1.061a.5.5,0,0,0,0-.707Z"
        />
      </g>
    </svg>
  )
}

type BlogIconProps = SvgIconProps

export const BlogIcon: React.FC<BlogIconProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 24.632 22" focusable="false" aria-hidden="true" />
}
